import { render, staticRenderFns } from "./BatchUpload.vue?vue&type=template&id=d84c6c7c&scoped=true"
import script from "./BatchUpload.vue?vue&type=script&lang=js"
export * from "./BatchUpload.vue?vue&type=script&lang=js"
import style0 from "./BatchUpload.vue?vue&type=style&index=0&id=d84c6c7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84c6c7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d84c6c7c')) {
      api.createRecord('d84c6c7c', component.options)
    } else {
      api.reload('d84c6c7c', component.options)
    }
    module.hot.accept("./BatchUpload.vue?vue&type=template&id=d84c6c7c&scoped=true", function () {
      api.rerender('d84c6c7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WayBill/BatchUpload.vue"
export default component.exports